module.exports = __webpack_public_path__ + "static/media/icon_theme_on.59c3fcb9.png";